import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "action-task-2",
  "use": "action-task-2-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"action-task-2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.743.063a.5.5 0 0 1 .24.569L6.654 5.5H11.5a.5.5 0 0 1 .366.841l-7 7.5a.5.5 0 0 1-.848-.473L5.345 8.5H.5a.5.5 0 0 1-.366-.841l7-7.5a.5.5 0 0 1 .61-.096Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol